export const PIN_TYPE = {
  pinned: "pinned",
  unpinned: "unpinned",
};

export const TAG_TYPE = {
  single: { en_name: "single", jp_name: "1つのみ選択可能", value: 1 },
  multiple: { en_name: "multiple", jp_name: "複数選択可能", value: 2 },
};
